export const NAV_MAIN = [
  { name: "Shop par besoin", path: "/shop/besoin", key: "besoin" },
  { name: "Shop par produit", path: "/shop/produit", key: "produit" },
  { name: "Guides & conseils", path: "/guides" },
  { name: "Ateliers & experts", path: "/ateliers" },
  { name: "Boutique Genève", path: "/boutique-geneve" },
  { name: "À propos", path: "/a-propos" },
  { name: "FAQ", path: "/faq" },
  { name: "Contact", path: "/contact" },
];

export const NEEDS = [
  { slug: "regles-cycle", name: "Règles & cycle" },
  { slug: "intimite", name: "Intimité" },
  { slug: "sexualite", name: "Sexualité" },
  { slug: "maternite-post-partum", name: "Maternité & post-partum" },
  { slug: "peri-menopause", name: "Péri-ménopause" },
  { slug: "ados", name: "Ados & premiers cycles" },
];

export const PRODUCT_CATS = [
  { slug: "culottes-menstruelles", name: "Culottes menstruelles" },
  { slug: "maillots-menstruels", name: "Maillots menstruels" },
  { slug: "cups-disques", name: "Cups & disques" },
  { slug: "serviettes-lavables", name: "Serviettes lavables" },
  { slug: "soins-intimes", name: "Soins intimes" },
  { slug: "lubrifiants", name: "Lubrifiants" },
  { slug: "complements", name: "Compléments" },
  { slug: "accessoires-cadeaux", name: "Accessoires & cadeaux" },
];

export const FAQ_ITEMS = [
  {
    q: "Où expédiez-vous ?",
    a: "Nous expédions en Suisse, France, Belgique, Allemagne, Italie, Espagne, Autriche, Pays-Bas et Luxembourg. Retrait gratuit à la boutique Genève.",
  },
  {
    q: "Quels sont les frais de livraison ?",
    a: "Livraison Suisse : 6.90 CHF, offerte dès 60 CHF. Europe : 12.90 CHF, offerte dès 90 CHF.",
  },
  {
    q: "Quels sont les délais de livraison ?",
    a: "Suisse : 2 à 3 jours ouvrés. Europe : 3 à 5 jours ouvrés. Retrait boutique disponible dès confirmation.",
  },
  {
    q: "Puis-je retourner un produit ?",
    a: "Oui, 30 jours pour changer d'avis sur les produits non ouverts (hors protections internes pour raisons d'hygiène).",
  },
  {
    q: "Comment entretenir ma culotte menstruelle ?",
    a: "Rincer à l'eau froide après usage, laver en machine 30°C en sac filet, sécher à l'air libre. Durée de vie : 150 cycles minimum.",
  },
  {
    q: "Puis-je bénéficier d'un conseil personnalisé ?",
    a: "Oui, nos expertes reçoivent en boutique Genève et par téléphone. Réservation sur la page Contact.",
  },
  {
    q: "Organisez-vous des ateliers ?",
    a: "Oui, ateliers mensuels sur le cycle, la ménopause, le post-partum. Voir la page Ateliers & experts.",
  },
];

export const TRUST_ITEMS = [
  { title: "Expédié depuis Genève", desc: "Emballage soigné, envoi sous 24 h.", icon: "truck" },
  { title: "Paiement sécurisé", desc: "Carte, TWINT, Apple Pay, Google Pay.", icon: "shield" },
  { title: "Retours simplifiés", desc: "30 jours pour changer d'avis.", icon: "rotate" },
  { title: "Nos expertes à l'écoute", desc: "Conseil humain et discret.", icon: "heart" },
];
